import { Images } from '../../../../constants'

export const PORTAL_CONTENTS = {
  cards: [
    {
      head: 'Overall Position',
      subText: '2nd',
      color: '#8A70D6',
      color2: '#BDA6FF',
      path: '/student/portal/results',
    },
    {
      head: 'Total Subjects',
      subText: '12',
      color: '#FCAB5E',
      color2: '#FFCFA2',
      path: '/',
    },
  ],

  events: [
    {
      date1: 2,
      date2: 'jan',
      title: 'Principal Football Cup',
      time: '10am',
      color: '#5792F0',
    },
    {
      date1: 23,
      date2: 'jan',
      title: 'Inter House Sport',
      time: '10am',
      color: '#FFB0C8',
    },
    {
      date1: 15,
      date2: 'Feb',
      title: 'Swimming Class',
      time: '4pm',
      color: '#B395F3',
    },
    {
      date1: 28,
      date2: 'Feb',
      title: 'Visitation to the Zoo',
      time: '3pm',
      color: '#E9B575',
    },
    {
      date1: 28,
      date2: 'Feb',
      title: 'Excursion to Aso Rock',
      time: '11am',
      color: '#E9B575',
    },
  ],

  timeTable: [
    {
      subject: 'Mathematics',
      time: '8:00 - 9:30',
    },
    {
      subject: 'Chemistry',
      time: '9:30 - 10:30',
    },
    {
      subject: 'Break Time',
      time: '10:30 - 11:00',
    },
  ],

  content: [
    {
      img: Images.calculator,
      subject: 'mathematics',
      chapters: 12,
      bgColor: '#FFF0E1',
      color: '#FCAB5E',
    },
    {
      img: Images.discovery,
      subject: 'Physics',
      chapters: 16,
      bgColor: '#E9E3FE',
      color: '#8A70D6',
    },
    {
      img: Images.science,
      subject: 'Chemistry',
      chapters: 14,
      bgColor: '#E5F3FE',
      color: '#579BE4',
    },
    {
      img: Images.science,
      subject: 'Geography',
      chapters: 14,
      bgColor: '#E5F3FE',
      color: '#8C1BAB',
    },
    {
      img: Images.calculator,
      subject: 'mathematics',
      chapters: 12,
      bgColor: '#FFF0E1',
      color: '#FCAB5E',
    },
  ],
}

export const PORTAL_RESULTS_CONTENT = {
  selectors: [
    {
      title: 'Result type',
      options: ['Exam Result', 'Test Result', 'Assignment scores'],
    },
    {
      title: 'Sort by',
      options: ['First Term', 'Second Term', 'Third Term'],
    },
  ],

  result: [
    {
      subject: 'English Language',
      Remark: 'Good',
      score: 70,
    },
    {
      subject: 'Mathematics',
      Remark: 'Very Good',
      score: 81,
    },
    {
      subject: 'Social Studies',
      Remark: 'Excellent',
      score: 98,
    },
    {
      subject: 'Physics',
      Remark: 'Good',
      score: 65,
    },
    {
      subject: 'Chemistry',
      Remark: 'Good',
      score: 78,
    },
    {
      subject: 'Information Techology',
      Remark: 'Excellent',
      score: 99,
    },
    {
      subject: 'Biology',
      Remark: 'Pass',
      score: 45,
    },
  ],
}

export const PORTAL_MATERIALS = {
  options: ['SS1', 'SS2', 'SS3'],

  content: [
    {
      img: Images.calculator,
      subject: 'mathematics',
      chapters: 12,
      bgColor: '#FFF0E1',
      color: '#FCAB5E',
    },
    {
      img: Images.discovery,
      subject: 'Physics',
      chapters: 16,
      bgColor: '#E9E3FE',
      color: '#8A70D6',
    },
    {
      img: Images.science,
      subject: 'Chemistry',
      chapters: 14,
      bgColor: '#E5F3FE',
      color: '#579BE4',
    },
    {
      img: Images.science,
      subject: 'Geography',
      chapters: 14,
      bgColor: '#E5F3FE',
      color: '#8C1BAB',
    },
    {
      img: Images.calculator,
      subject: 'mathematics',
      chapters: 12,
      bgColor: '#FFF0E1',
      color: '#FCAB5E',
    },
    {
      img: Images.discovery,
      subject: 'Physics',
      chapters: 16,
      bgColor: '#E9E3FE',
      color: '#8A70D6',
    },
    {
      img: Images.science,
      subject: 'Chemistry',
      chapters: 14,
      bgColor: '#E5F3FE',
      color: '#579BE4',
    },
    {
      img: Images.science,
      subject: 'Geography',
      chapters: 14,
      bgColor: '#E5F3FE',
      color: '#8C1BAB',
    },
    {
      img: Images.calculator,
      subject: 'mathematics',
      chapters: 12,
      bgColor: '#FFF0E1',
      color: '#FCAB5E',
    },
    {
      img: Images.discovery,
      subject: 'Physics',
      chapters: 16,
      bgColor: '#E9E3FE',
      color: '#8A70D6',
    },
    {
      img: Images.science,
      subject: 'Chemistry',
      chapters: 14,
      bgColor: '#E5F3FE',
      color: '#579BE4',
    },
    {
      img: Images.science,
      subject: 'Geography',
      chapters: 14,
      bgColor: '#E5F3FE',
      color: '#8C1BAB',
    },
    {
      img: Images.calculator,
      subject: 'mathematics',
      chapters: 12,
      bgColor: '#FFF0E1',
      color: '#FCAB5E',
    },
    {
      img: Images.discovery,
      subject: 'Physics',
      chapters: 16,
      bgColor: '#E9E3FE',
      color: '#8A70D6',
    },
    {
      img: Images.science,
      subject: 'Chemistry',
      chapters: 14,
      bgColor: '#E5F3FE',
      color: '#579BE4',
    },
    {
      img: Images.science,
      subject: 'Geography',
      chapters: 14,
      bgColor: '#E5F3FE',
      color: '#8C1BAB',
    },
  ],
}
